// src/shared/api/axiosInstance.js
import axios from "axios";
import { getStrapiError } from "../lib/getStrapiError";

export const axiosBaseURL = `https://${process.env.REACT_APP_APP_URL}/api/v1`;

export const axiosInstance = axios.create({
  baseURL: axiosBaseURL,
  headers: { "Content-Type": "application/json" },
});

// Добавляем интерцептор для автоматической подстановки токена
axiosInstance.interceptors.request.use(
  (config) => {
    // Убираем token из URL если он там есть
    if (config.url && config.url.includes('token=')) {
      const url = new URL(config.url, config.baseURL);
      url.searchParams.delete('token');
      config.url = url.pathname + url.search;
    }
    
    // Добавляем токен в заголовки
    const token = localStorage.getItem('token') || getTokenFromSomewhere(); // Нужно реализовать получение токена
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  null,
  (err) => Promise.reject(getStrapiError(err) || err)
);

// Функция для получения токена (реализуйте в соответствии с вашей логикой)
function getTokenFromSomewhere() {
  // Например, из контекста, localStorage, или другого места
  return localStorage.getItem('auth_token') || '';
}